import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { SecurityService } from '../../security/security.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private securityService: SecurityService,
              private snackbar: MatSnackBar) {}

  canActivate(): Observable<boolean> {
    return this.securityService.currentUser$.pipe(
      map(user => {
        if (user) return true;
        this.snackbar.open('You are unauthorized for this action', 'BELLA+CANVAS', {
            duration: 1000
        });
      })
    )
  }
  
}